module.exports = __webpack_public_path__ + "static/media/i-13.ee08d016.svg";